import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import { CONTRACTS_EVENTS, CONTRACTS_NAMES, CONTRACTS_FUNCTIONS } from '#models/contracts/constants';
import * as ContractsService from '#services/ContractsService';
import MashingsActions from '#redux/Mashings/actions';
import { MODALS } from '#redux/Modal/constants';

import { WASH_TARGETS } from './constants';
import { mapAddWash, mapUpdateWashStep } from './mappers';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['GET_ALL_ADDED_WASHES', 'ADD_WASH'],
    ignoredActions: ['SET_CURRENT_WASH']
  }),
  '@@WASHES'
);

export const actionCreators = {
  getAllAddedWashes: () => ({
    type: actions.GET_ALL_ADDED_WASHES,
    target: WASH_TARGETS.ADDED_WASHES,
    payload: { event: CONTRACTS_EVENTS.WASH_ADDED, contractName: CONTRACTS_NAMES.WASH },
    service: ContractsService.getAllEvents
  }),
  addWash: (values, id) => ({
    type: actions.ADD_WASH,
    target: WASH_TARGETS.ADD_WASH,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.ADD_WASH,
      contractName: CONTRACTS_NAMES.WASH,
      functionParams: mapAddWash(values)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(
          MashingsActions.updateMashById({
            id,
            values: mapUpdateWashStep(values),
            postSuccessAction: MashingsActions.getAllMashesAndCloseModal(MODALS.WASH_STEP)
          })
        );
      })
    ]
  }),
  setCurrentWash: payload => ({
    type: actions.SET_CURRENT_WASH,
    target: WASH_TARGETS.CURRENT_WASH,
    payload
  })
};

export default actionCreators;
